<template>
  <!--html do computador-->
  <div class="hidden-sm hidden-xs">
    

      <!-- barra superior -->
      <div class="wrap">
        <div class="container">
          <div v-if="topoMenu != ''" class="row justify-content-between">
            <div class="col-12 col-md d-flex align-items-center">
              <p class="mb-0 phone"><span class="mailus">Telefone:</span> {{ topoMenu[0].itiNome }} ou <span
                class="mailus">e-mail:</span> {{ topoMenu[0].itiReferencia }}</p>
            </div>
            <div v-if="redesSociais !=''"  class="col-12 col-md d-flex justify-content-md-end">
              <div class="social-media">
                <p class="mb-0 d-flex">
                  <a v-if="redesSociais[0].itiNome !=''" :href="redesSociais[0].itiNome" target="_blank" class="d-flex align-items-center justify-content-center"><span class="fa fa-facebook"><i
                        class="sr-only">Facebook</i></span></a>
                  <a v-if="redesSociais[0].itiReferencia !=''" :href="redesSociais[0].itiReferencia" target="_blank" class="d-flex align-items-center justify-content-center"><span class="fa fa-instagram"><i
                        class="sr-only">Instagram</i></span></a>
                  <a v-if="redesSociais[0].itiCampoExtra2 !=''" :href="redesSociais[0].itiCampoExtra2" target="_blank" class="d-flex align-items-center justify-content-center"><span class="fa fa-linkedin"><i
                        class="sr-only">Linkedin</i></span></a>
                  <a v-if="redesSociais[0].itiCampoExtra1 !=''" :href="redesSociais[0].itiCampoExtra1" target="_blank" class="d-flex align-items-center justify-content-center"><span class="fa fa-youtube"><i
                        class="sr-only">Youtube</i></span></a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- menu -->
      <nav class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div class="container">
          <router-link to="/"><img src="/images/performance_logo_header.svg" alt="" style="width: 300px;"></router-link>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav"
            aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="oi oi-menu"></span> Menu
          </button>

          <div class="collapse navbar-collapse" id="ftco-nav">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item"><router-link to="/" class="nav-link">Home</router-link></li>
              <li class="nav-item"><router-link to="/empresa" class="nav-link">A Empresa</router-link></li>
              <li class="nav-item"><router-link to="/manutencao" class="nav-link">Manutenção</router-link></li>
              <li class="nav-item"><router-link to="/solucoes" class="nav-link">Soluções</router-link></li>
              <li class="nav-item"><router-link to="/orcamento" class="nav-link">Orçamento</router-link></li>
              <li class="nav-item"><router-link to="/blog" class="nav-link">Blog</router-link></li>
              <li class="nav-item"><router-link to="/contato" class="nav-link">Contato</router-link></li>
            </ul>
          </div>
        </div>
      </nav>
      <!-- END nav -->

    

  </div>

  <!--html do celular-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3;">
    <div class="row celular-alinhado">
      <div class="col-3" style="margin-top: 15px;">
        <v-menu :close-on-content-click="true" >
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title class=" menu"
                  style="color: #000000;">Home</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/empresa"><v-list-item-title class=" menu"
                  style="color: #000000;">A Empresa</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/manutencao"><v-list-item-title class=" menu"
                  style="color: #000000;">Manutenção</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/solucoes"><v-list-item-title class=" menu"
                  style="color: #000000;">Soluções</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/orcamento"><v-list-item-title class=" menu"
                  style="color: #000000;">Orçamento</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/blog"><v-list-item-title class=" menu"
                  style="color: #000000;">Blog</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title class=" menu"
                  style="color: #000000;">Contato</v-list-item-title></router-link></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img src="/images/performance_logo_header.svg" alt="" style="width: 100%;"></router-link>
      </div>
    </div>
  </div>

     <!-- END footer -->
     <div class="whatsapp-fixo" v-if="topoMenu!=''">
    <a :href="topoMenu[0].itiLinkBtn1" target="_blank">
        <img v-if="topoMenu[0].itiLinkBtn1!=''" src="/images/atendimentowats.png"  alt="Fale Conosco pelo WhatsApp" style="width: 200px;" />
    </a>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',
  components: {

  },
  data: () => ({
    topoMenu: [],
    redesSociais: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //texto e logo avance 
    axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topo menu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

      // redes sociais 
    axios.get('/Process/InsInstitucional/institucional/20/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('rodapé')
        //console.log(this.redesSociais)
      })
      .catch(error => {
        console.error(error);
      });
      
  }
};
</script>

<style scoped>
.menuTamanho {
  size: 16px;
  text-align: left;
  line-height: 1.5;
}

/* WHATSAPP FIXO */
.whatsapp-fixo {
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 999;
  }
</style>
